import { useEffect, useState } from "react";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "sonner";
import { Loader2, KeyRound } from "lucide-react";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { SiteHeader, PageFooter } from "@/components/brand/Brand";
import { api, apiError } from "@/lib/api";
import { useAuth } from "@/lib/auth";
import { useI18n } from "@/lib/i18n/i18n";

export default function Activar() {
  const { token } = useParams();
  const nav = useNavigate();
  const { startSession } = useAuth();
  const { t } = useI18n();
  const [info, setInfo] = useState(null);
  const [error, setError] = useState("");
  const [pw, setPw] = useState("");
  const [pw2, setPw2] = useState("");
  const [busy, setBusy] = useState(false);

  useEffect(() => {
    api.get(`/auth/activation/${token}`).then((r) => setInfo(r.data)).catch((e) => setError(apiError(e).message));
  }, [token]);

  const submit = async (e) => {
    e.preventDefault();
    if (pw !== pw2) { setError(t("Las contraseñas no coinciden")); return; }
    setBusy(true);
    try {
      const { data } = await api.post("/auth/activate", { token, password: pw });
      startSession(data);
      toast.success(t("Cuenta activada"));
      nav("/empresa/scanner", { replace: true });
    } catch (err) {
      setError(t(apiError(err).message));
      setBusy(false);
    }
  };

  return (
    <div className="min-h-screen bg-slate-50" data-testid="activate-page">
      <SiteHeader />
      <main className="mx-auto max-w-md px-5 py-16">
        <p className="text-xs font-bold uppercase tracking-[0.25em] text-upv">{t("Acceso empresas")}</p>
        <h1 className="mt-3 font-display text-4xl font-extrabold tracking-tight">{t("ACTIVA TU CUENTA")}</h1>
        {info && <p className="mt-3 text-slate-600" data-testid="activate-info">{info.name} · {info.company} · <span className="font-mono text-sm">{info.email}</span></p>}
        <form onSubmit={submit} className="mt-8 space-y-5 rounded-[28px] border border-slate-200 bg-white p-6 shadow-sm" data-testid="activate-form">
          <div className="space-y-2"><Label className="text-xs font-semibold uppercase tracking-wider text-slate-600">{t("Contraseña")}</Label><Input type="password" value={pw} onChange={(e) => setPw(e.target.value)} className="h-12 rounded-xl" data-testid="activate-password-input" disabled={!info} /></div>
          <div className="space-y-2"><Label className="text-xs font-semibold uppercase tracking-wider text-slate-600">{t("Repite la contraseña")}</Label><Input type="password" value={pw2} onChange={(e) => setPw2(e.target.value)} className="h-12 rounded-xl" data-testid="activate-password2-input" disabled={!info} /></div>
          <p className="text-xs text-slate-500">{t("Mínimo 8 caracteres, con letras y números.")}</p>
          {error && <p className="rounded-xl bg-rose-50 px-4 py-3 text-sm font-medium text-rose-700" data-testid="activate-error">{t(error)}</p>}
          <button type="submit" disabled={busy || !info} className="flex h-14 w-full items-center justify-center gap-2 rounded-2xl bg-upv font-display font-bold tracking-wider text-white hover:bg-upv-dark disabled:opacity-60" data-testid="activate-submit-button">
            {busy ? <Loader2 className="h-5 w-5 animate-spin" /> : <KeyRound className="h-5 w-5" />} {t("ACTIVAR CUENTA")}
          </button>
        </form>
      </main>
      <PageFooter />
    </div>
  );
}
